import state from './dialcastrecipientgroup.state'
import mutations from './dialcastrecipientgroup.mutations'
import actions from './dialcastrecipientgroup.actions'

export default {
  state,
  mutations,
  actions
}
